import IMAGE_LOGO from "@/assets/ic_logo.png";
import IMAGE_BACKGROUND_DEFAULT from "@/assets/background-default.png";
import IMAGE_LOGO_DEFAULT from "@/assets/logo-default.png";
import IMAGE_LOGO_DEFAULT_WHITE from "@/assets/logo_default_white.png";
import IMAGE_REGISTER_SUCCESS from "@/assets/register_success.png";
import IMAGE_ACCOUNT_CENTER_BACKGROUND from "@/assets/account_center_background.png";
import IMAGE_STAFF_LIST from "@/assets/staff_list.png";
import IMAGE_RESET_PASSWORD from "@/assets/reset_password.png";
import IMAGE_SAFE_CENTER from "@/assets/safe_center.png";
import IMAGE_USER_HEADSHOT from "@/assets/user_headshot.png";
import IMAGE_LOGIN_ERROR from "@/assets/login_error.png";
import IMAGE_RECYCLE_BIN_EMPTY from "@/assets/recycle_bin_empty.png";
import IMAGE_STAFF_LIST_EMPTY from "@/assets/staff_list_empty.png";
import IMAGE_ENTERPRISE_LOGO from "@/assets/qyb_logo.png";
import IMAGE_FLAGSHIP_LOGO from "@/assets/qjb_logo.png";
import IMAGE_HAOJINGYING_LOGO from "@/assets/hjy_logo.png";
import IMAGE_YJINGYING_LOGO from "@/assets/yjy_logo.png";
import IMAGE_HJY_LOGO from "@/assets/hjy-enter.svg?url";
import IMAGE_TRY_AGAGIN from "@/assets/try_again.png";
import IMAGE_VERIFYCODE_REFRESH from "@/assets/verifycode_refresh.gif"
import IMAGE_LOGO_ACCOUNT_CENTER from "@/assets/logo-account-center.png"
import IMAGE_SPLIT_LINE from "@/assets/split-line.png"
import SECURITY_CENTER_BACKGROUND from "@/assets/security_center_background.png"
import IMAGE_SECURITY_RANK_LOW from "@/assets/rank-low.png"
import IMAGE_SECURITY_RANK_MID from "@/assets/rank-mid.png"
import IMAGE_SECURITY_RANK_HIGH from "@/assets/rank-high.png"
import IMAGE_SECURITY_DOT from "@/assets/security-dot.png"
import IMAGE_ACCOUNT from '@/assets/account.png'
import IMAGE_MOBLIE from '@/assets/moblie.png'
import IMAGE_APPEAL from '@/assets/appeal.png'
import IMAGE_ACCOUNT_BG from '@/assets/account-info-bg.png'
// @ts-ignore
import IMAGE_HUICE_QRCODE from '@/assets/svg/huice-qrcode.svg?url='
// @ts-ignore
import IMAGE_HUICE_COMPUTER from '@/assets/svg/computer-label.svg?url='
import PRODUCT_MAP_MP4 from '@/assets/map.mp4'

// @ts-ignore
import IMAGE_JSB_3_0 from '@/assets/svg/jsb3_0_logo.svg?url='
// @ts-ignore
import IMAGE_HUICE from '@/assets/svg/huice_logo.svg?url='
// @ts-ignore
import IMAGE_GONGYINGLIAN_LOGO from "@/assets/svg/gyl_logo.svg?url=";

export class Images {
  public static LOGO = IMAGE_LOGO
  public static BACKGROUND_DEFAULT = IMAGE_BACKGROUND_DEFAULT
  public static LOGO_DEFAULT = IMAGE_LOGO_DEFAULT
  public static REGISTER_SUCCESS = IMAGE_REGISTER_SUCCESS
  public static LOGO_DEFAULT_WHITE = IMAGE_LOGO_DEFAULT_WHITE
  public static ACCOUNT_CENTER_BACKGROUND = IMAGE_ACCOUNT_CENTER_BACKGROUND
  public static STAFF_LIST = IMAGE_STAFF_LIST
  public static RESET_PASSWORD = IMAGE_RESET_PASSWORD
  public static SAFE_CENTER = IMAGE_SAFE_CENTER
  public static USER_HEADSHOT = IMAGE_USER_HEADSHOT
  public static LOGIN_ERROR = IMAGE_LOGIN_ERROR
  public static RECYCLE_BIN_EMPTY = IMAGE_RECYCLE_BIN_EMPTY
  public static STAFF_LIST_EMPTY = IMAGE_STAFF_LIST_EMPTY
  public static ENTERPRISE_LOGO = IMAGE_ENTERPRISE_LOGO
  public static HJY_LOGO = IMAGE_HJY_LOGO
  public static FLAGSHIP_LOGO = IMAGE_FLAGSHIP_LOGO
  public static HAOJINGYING_LOGO = IMAGE_HAOJINGYING_LOGO
  public static YJINGYING_LOGO = IMAGE_YJINGYING_LOGO
  public static IMAGE_GONGYINGLIAN_LOGO = IMAGE_GONGYINGLIAN_LOGO
  public static TRY_AGAIN = IMAGE_TRY_AGAGIN
  public static VERIFYCODE_REFRESH = IMAGE_VERIFYCODE_REFRESH
  public static LOGO_ACCOUNT_CENTER = IMAGE_LOGO_ACCOUNT_CENTER
  public static SPLIT_LINE = IMAGE_SPLIT_LINE
  public static SECURITY_CENTER_BACKGROUND = SECURITY_CENTER_BACKGROUND
  public static RANK_LOW = IMAGE_SECURITY_RANK_LOW
  public static RANK_MID = IMAGE_SECURITY_RANK_MID
  public static RANK_HIGH = IMAGE_SECURITY_RANK_HIGH
  public static SECURITY_DOT = IMAGE_SECURITY_DOT
  public static LOGIN_ACCOUNT = IMAGE_ACCOUNT
  public static IMAGE_MOBLIE = IMAGE_MOBLIE
  public static IMAGE_APPEAL = IMAGE_APPEAL
  public static IMAGE_ACCOUNT_BG = IMAGE_ACCOUNT_BG
  public static IMAGE_HUICE_QRCODE =IMAGE_HUICE_QRCODE
  public static IMAGE_HUICE_COMPUTER =IMAGE_HUICE_COMPUTER
  public static IMAGE_FLAGSHIP_LOGO =IMAGE_FLAGSHIP_LOGO
  public static MP4_PRODUCT_MAP  =PRODUCT_MAP_MP4
  public static JSB_LOGO=IMAGE_JSB_3_0
  public static IMAGE_HUICE_LOGO=IMAGE_HUICE
}

